import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";
import { Link } from "react-router-dom";

const BaseWrap = styled.div`
    position: absolute;
    top: ${toRem(40)};
    left: calc(100% + ${toRem(4)});
    width: min(${toRem(450)}, 40vw);
    height: min(${toRem(515)}, 45dvh);
    min-height: ${toRem(515)};
    border-radius: ${toRem(16)};
    box-shadow:
            ${toRem(0)} ${toRem(32)} ${toRem(32)} ${toRem(0)} ${COLORS.NEUTRAL.CONTAINER_SOFT},
            ${toRem(0)} ${toRem(0)} ${toRem(32)} ${toRem(0)} ${COLORS.NEUTRAL.CONTAINER_MUTED};
    background: ${COLORS.BG.SURFACE1};
    padding: ${toRem(16)};
    z-index: 10;

    display: flex;
    flex-direction: column;
`;

export const AnimatedWrap = styled(BaseWrap)`
    &.hud-slide-enter {
        opacity: 0;
        transform: translateX(${toRem(-12)});
    }
    &.hud-slide-enter-active {
        opacity: 1;
        transform: translateX(0);
        transition: opacity 200ms ease, transform 200ms ease;
    }
    &.hud-slide-exit {
        opacity: 1;
        transform: translateX(0);
    }
    &.hud-slide-exit-active {
        opacity: 0;
        transform: translateX(${toRem(-12)});
        transition: opacity 150ms ease, transform 150ms ease;
    }
`;

export const Head = styled.div`
  display: flex;
  gap: ${toRem(8)};
  justify-content: space-between;
  padding: ${toRem(16)} 0;
`

export const ToAll = styled(Link)`
  font-size: ${toRem(14)};
  color: ${COLORS.FG.MUTED};

  @media (any-hover: hover){
    &:hover{
      text-decoration: underline;
    }
  }
`

export const Title = styled.div`
  color: ${COLORS.FG.SOFT};
  font-size: ${toRem(16)};
  font-weight: 400;
  line-height: ${20 / 16};
  font-weight: 700;
`;
